import { render, staticRenderFns } from "./CreateAdHocModel.vue?vue&type=template&id=1a3d6562&"
import script from "./CreateAdHocModel.vue?vue&type=script&lang=js&"
export * from "./CreateAdHocModel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports